export { Tr } from './Tr';
export { Tr as TrView } from './Tr.views';